import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { downloadFirstConsultationPdf } from '@/api/firstConsultations/firstConsultationSharingApi';
import { saveDownloadedFile, type DownloadedFile } from '@/api/fileDownload';

export function useDownloadFirstConsultationPdf(): UseMutationResult<
  DownloadedFile,
  Error,
  string
> {
  return useMutation({
    mutationFn: function requestFirstConsultationPdf(consultationId: string) {
      return downloadFirstConsultationPdf(consultationId);
    },
    onSuccess: saveDownloadedFile,
  });
}
